"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.classNameBuilder = void 0;
/**
 * Inspired by Angular's NgClass. This function accepts any number of object and string that
 * will be parsed and combined into a single class name string.
 *
 * The function will add all not-empty string, all not-empty string inside
 * an array of strings, and all string keys for objects where the value is `true`  to the final result.
 *
 * This function automatically trims all string to remove whitespace at beginning and end of functions.
 *
 * @TODO Add automated Jest testing for this helper function
 *
 * @param props A list of strings, string arrays and string-to-boolean records to be parsed
 * @returns a formatted string that includes class names provided through the parameter
 */
var classNameBuilder = function classNameBuilder() {
  var segments = [];
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  for (var _i = 0, _props = props; _i < _props.length; _i++) {
    var p = _props[_i];
    segments.push(parseProp(p));
  }
  return segments.filter(function (s) {
    return !!s;
  }).join(" ");
};
exports.classNameBuilder = classNameBuilder;
var parseProp = function parseProp(prop) {
  if (!prop) {
    return "";
  }
  if (typeof prop === "string") {
    return prop.trim();
  }
  if (Array.isArray(prop)) {
    return prop.map(function (c) {
      return c.trim();
    }).join(" ");
  }
  var result = [];
  for (var _i2 = 0, _Object$keys = Object.keys(prop); _i2 < _Object$keys.length; _i2++) {
    var name = _Object$keys[_i2];
    var flag = prop[name];
    var trimmed = name.trim();
    if (flag && trimmed) {
      result.push(trimmed);
    }
  }
  return result.filter(function (s) {
    return !!s;
  }).join(" ");
};
var _default = classNameBuilder;
exports.default = _default;